import { AppointmentCalendarIntegrationsRequest } from 'types/appointment'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../services'
import { useQuery } from 'react-query'

const hookName = 'useAppointmentCalendarIntegrations'
const log = logFactory(hookName)

const useAppointmentCalendarIntegrations = (request: AppointmentCalendarIntegrationsRequest, enabled = true) => {
  const { getAppointmentCalendarIntegrations, isReady } = useAppointmentsService()

  const doQuery = async () => {
    log(`📆 Fetching appointment calendar integrations...`, request)

    const results = await getAppointmentCalendarIntegrations(request)

    log(`📆 Returned appointment calendar integrations...`, results)

    return results
  }

  return useQuery([hookName, request], doQuery, {
    enabled: isReady && enabled,
  })
}

export { useAppointmentCalendarIntegrations }
